import { toNumber } from './helpers';

Number.from = toNumber

declare global {
	interface NumberConstructor {
		from<T = any>(value: any, defaultValue: T): number | T;
	}
}